// removed by extract-text-webpack-plugin
module.exports = {"page":"_39My58mDB _2l0xl0HVf yJ3aJSEV8 _2D5O9dQtF _-1CuDyzo1","image-container":"_3T1cJrKGp _3lHRe10pm _3WEPqh4Fi _1zU9pZnM6 _8QSagsfVR _252nX0Tjy","image":"_2Eu-e0Rcj _3EiT4eWlg Ir07ODalK _1KpFNFQtR _2l0xl0HVf _1-iZsM4yd _2K2V57EzT _2ybVBwT_r _28xcDdlWw _2tfEqJe_D","buttons":"_3cksuRiZ- _2l0xl0HVf _2rM1geq7b _1II0OCq4x _3l91ZaNqh pzmz6Pfas","button-group":"_3uBZQ2wYh GuylogL4m _2l0xl0HVf","save-button":"_1MiYeV6aA _1jY4uEptA _1gxOMRlp0","overlay":"qe0n_Acy2 _3EiT4eWlg Ir07ODalK _2zodtWoIz _3Sg-Aoqrk _1KpFNFQtR u4uSNwmk6 fRuvB2aOu _17qxy1jyE _34YKmqAjT qigzzAbil _1-iZsM4yd"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/event-group-details-page/event-group-details-page.css
 ** module id = 2186
 ** module chunks = 0
 **/